import { useEffect, useState } from "react";

import baseLogo from "./assets/logos/base.png";
import avaxLogo from "./assets/logos/avalanche.png";
// add more later
// import ethLogo from "./assets/logos/ethereum.png";
// import arbLogo from "./assets/logos/arbitrum.png";

const CHAIN_CONFIG = {
  base: {
    label: "BASE",
    logo: baseLogo,
  },
  avax: {
    label: "AVALANCHE",
    logo: avaxLogo,
  },

  // polygon: { label: "POLYGON", logo: polygonLogo },
  // arbitrum: { label: "ARBITRUM", logo: arbLogo },
};

export default function ChainScrollIndicator({ chain }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 20);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const config = CHAIN_CONFIG[chain] || {
    label: "UNKNOWN",
    logo: baseLogo,
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 70,
        right: 12,
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "6px",
        borderRadius: 12,
        background: "white",
        color: "white",
        fontSize: 12,
        backdropFilter: "blur(8px)",
        opacity: visible ? 1 : 0,
        transition: "0.3s",
        zIndex: 9999,
      }}
    >
      <img
        src={config.logo}
        alt={config.label}
        style={{ width: "30px", height: "100%" }}
      />
    </div>
  );
}
